import type { IconSvgObject } from './types';

const MessageProgrammingIcon: IconSvgObject = [
  ["path", { d: "M22 15V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V15C2 16.6569 3.34315 18 5 18H8C8.55228 18 9 18.4477 9 19V22L14.4962 18.3359C14.8247 18.1169 15.2107 18 15.6056 18H19C20.6569 18 22 16.6569 22 15Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 8L18 10L16 12M8 8L6 10L8 12M13 7L11 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MessageProgrammingIcon;
